module.exports = __webpack_public_path__ + "static/img/new-44.a42fd6d8.jpg";